import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import ResponsiveForm from '../../Form';
import { parseAccountData, parseAccountSubscriptionData, validate } from '../../../../Helpers';
import {
  EDIT_INPUTS,
  ACCOUNT_FORM as form,
  ACCOUNT_VALIDATIONS,
} from './config';

let EditAccountForm = ({ handleSubmit, subscriptions, loading = false, ...props }) => (
  <ResponsiveForm
    {...props}
    inputs={EDIT_INPUTS}
    loading={loading}
    onSubmit={handleSubmit}
    values={{ subscriptions }}
  />
);

EditAccountForm = reduxForm({
  form,
  validate: validate(ACCOUNT_VALIDATIONS),
})(EditAccountForm);

const selector = formValueSelector(form);

const mapStateToProps = ({
  accounts: {
    item,
  },
  allIntegrators: {
    items: integrators,
  },
  allServices: {
    items: services,
  },
  ...state
}) => ({
  initialValues: parseAccountSubscriptionData(
    item ? parseAccountData(item.data) : {},
    integrators[1] ? integrators[1] : [],
    services[1] ? services[1] : [],
  ),
  subscriptions: selector(state, 'subscriptions'),
});

export default connect(
  mapStateToProps
)(EditAccountForm);
